import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

export function PremiumPage() {
  const [params] = useSearchParams();
  const { user, loading } = useAuth();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const sessionId = params.get('session_id');
    const success = params.get('success');
    if (success === '1' && sessionId && user) {
      api('/economy/verify-session', {
        method: 'POST',
        body: JSON.stringify({ sessionId }),
      }).then(() => {
        setMsg('Premium activé ! Bon jeu en mode infini.');
      }).catch(() => setMsg('Paiement reçu — rafraîchis la page si le statut ne se met pas à jour.'));
    }
    if (params.get('canceled') === '1') {
      setMsg('Paiement annulé.');
    }
  }, [params, user]);

  const handleCheckout = async () => {
    setBusy(true);
    setMsg('');
    try {
      const res = await api<{ url: string }>('/economy/create-checkout-session', { method: 'POST' });
      window.location.href = res.url;
    } catch (e: unknown) {
      const err = e as { data?: { error?: string } };
      setMsg(err.data?.error === 'payments_not_configured'
        ? 'Paiements pas encore configurés sur le serveur.'
        : 'Impossible de lancer le paiement.');
    } finally {
      setBusy(false);
    }
  };

  if (loading) {
    return <main className="page premium"><p className="loading">Chargement…</p></main>;
  }

  return (
    <main className="page premium">
      <div className="result-card premium-card">
        <h1>{t('premium.title')}</h1>
        <p className="premium-price">{t('premium.price')}</p>
        <ul className="premium-perks">
          <li>{t('premium.perk1')}</li>
          <li>{t('premium.perk2')}</li>
        </ul>

        {user?.isPremium ? (
          <>
            <p className="premium-active">{t('premium.active')}</p>
            <Link to="/practice" className="btn primary">{t('premium.play')}</Link>
          </>
        ) : user ? (
          <>
            <p className="premium-consent">{t('premium.consent')}</p>
            <button type="button" className="btn primary" onClick={handleCheckout} disabled={busy}>
              {busy ? 'Redirection…' : t('premium.subscribe')}
            </button>
            <Link to="/login" className="link-muted">Déjà premium ? Reconnecte-toi</Link>
          </>
        ) : (
          <Link to="/login" className="btn primary">{t('premium.loginFirst')}</Link>
        )}

        {msg && <p className="premium-msg">{msg}</p>}
      </div>
      <nav className="result-nav">
        <Link to="/gallery">{t('gallery.title')}</Link>
        <Link to="/">Accueil</Link>
      </nav>
    </main>
  );
}
